$(document).ready(function () {
    $('.promo-banner__timer').each(function () {
        const $timer = $(this);
        const targetDate = new Date($timer.data('counter-date'));

        function refresh() {
            const counter = getTimeDiff(targetDate);

            $timer.find('.counter-days .counter-value').text(padZero(counter.days));
            $timer.find('.counter-hours .counter-value').text(padZero(counter.hours));
            $timer.find('.counter-minutes .counter-value').text(padZero(counter.minutes));
            $timer.find('.counter-seconds .counter-value').text(padZero(counter.seconds));
            $timer.find('.promo-banner__counters').addClass('visible');
        }

        refresh();
        setInterval(refresh, 1000);
    });

    function padZero(num) {
        return num.toString().padStart(2, '0');
    }

    function getTimeDiff(targetDate) {
        const now = new Date();
        const timeDiff = targetDate.getTime() - now.getTime();

        if (isNaN(timeDiff) || timeDiff <= 0) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            }
        }

        return {
            days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
            hours: Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((timeDiff % (1000 * 60)) / 1000),
        }
    }
});
